<sortable state="{ props.state }">
  <slot shadow="{ shadow }"/>
  <script>
    export default {
      element: null,
      startIndex: -1,
      endIndex: -1,
      onBeforeMount() {
        const stateMode = this.props.state == 'false' ? false : (!!this.props.state);
        this.shadow = {
          stateMode,
          getContainer: () => this.root,
          getElement: () => this.element,
          getStartIndex: () => this.startIndex ?? -1,
          setStartIndex: (i) => this.startIndex = i,
          getEndIndex: () => this.endIndex ?? -1,
          setEndIndex: (i) => this.endIndex = i,
          onChange: (element) => {
            this.element = element;
          },
        };
      } 
    };
  </script>
</sortable>